import React from 'react'
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiSearch } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { getReportListForCommisions } from '../../reports/store/thunk';



export const Search = () => {

    // const { empleados } = useSelector(state => state.empleados);
    const { empleados, recepcionistas } = useSelector(state => state.empleados);
    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    const dispatch = useDispatch();
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes;
    let today = f.getFullYear() + "-" + mes + "-" + dia;

    const searchData = (data) => {
        console.log(data);
        
        dispatch(getReportListForCommisions(data.fechaInicial, data.fechaFinal, data.empleado, data.opcionCC, data.opcionEmpleado));
    }

    const opcionEmpleado = watch("opcionEmpleado", "1");
    const dataToShow = opcionEmpleado === "1" ? empleados : recepcionistas;
    const labelText = opcionEmpleado === "1" ? "Técnico(s):" : "Recepcionista(s):";
    const rolEsperado = opcionEmpleado === "1" ? 3 : 2;

    return (
        <div className="card">
            <div className="card-body">
                <form className='row' onSubmit={handleSubmit(searchData)}>

                    <div className='col-12 mb-2'>
                        <input type="radio" className="btn-check" id="option5" {...register("opcionEmpleado")} value="1" defaultChecked />
                        <label className="btn btn-outline-primary me-2" htmlFor="option5">Tecnico(s)</label>

                        <input type="radio" className="btn-check" id="option6" {...register("opcionEmpleado")} value="2" />
                        <label className="btn btn-outline-primary" htmlFor="option6">Recepcionista(s)</label>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-2 mt-2'>
                        <label className="form-label">{labelText}</label>
                        <select className="form-select" defaultValue={'0'} {...register("empleado")}>
                            <option value={'0'}>TODOS</option>
                            {dataToShow.map((item, index) => (
                                item.ESTADO == 1 && item.ROL_ID == rolEsperado ? (
                                    <option key={index} value={item.ID} className='text-uppercase'>
                                        ({item.USER}) | {item.NOMBRE}
                                    </option>
                                ) : null
                            ))}
                        </select>
                    </div>

                    <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-2'>
                        <label className="form-label">Fecha de Inicio:</label>
                        <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                        {
                            errors.fechaInicial &&
                            <div className='text-left-5 mt-2'>
                                <FiAlertTriangle size="18" color="#dc3545" />
                                <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                            </div>
                        }
                    </div>

                    <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-2 ">
                        <label className="form-label">Fecha de Termino:</label>
                        <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                    </div>

                    <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1 mt-3">
                        <div className="mb-3 mt-3">
                            <button type="submit" className="btn btn-outline-secondary">
                                <FiSearch size="20" /> Buscar
                            </button>
                        </div>
                    </div>

                    <div className='d-flex  ms-2'>
                        <div className="form-check">
                            <input className="form-check-input" type="radio"  {...register("opcionCC")} value="1" defaultChecked />
                            <label className="form-check-label" >
                                Si, aplicar control de calidad
                            </label>
                        </div>
                        <div className="form-check ms-3 ">
                            <input className="form-check-input" type="radio"  {...register("opcionCC")} value="2" />
                            <label className="form-check-label" >
                                No, aplicar control de calidad
                            </label>
                        </div>
                    </div>


                </form>
            </div>
        </div>
    )
}
